import React from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

function CustomPhoneInput({ value, onChange }: any) {
  return <PhoneInput defaultCountry="sa" value={value} onChange={onChange} />;
}

export default CustomPhoneInput;
